// Imports
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\r\nrsb-sidebar {\r\n    background: #0167cc;\r\n}", "",{"version":3,"sources":["webpack://src/styles.css"],"names":[],"mappings":";AACA;IACI,mBAAmB;AACvB","sourcesContent":["\r\nrsb-sidebar {\r\n    background: #0167cc;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
